import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';

const GoToRegisterButtons = ({ areChangesPending, submitting, onCharge, onGoToProducts, showGoToProducts }) => (
  <div className="u-ml- u--mt- u-mb- o-flexbox__item">
    <div className="u-font-color-grey u-fontsize-small u-inline-block" display-if={areChangesPending}>
      {t('appointment:form.charge_buttons.save_before_charging')}
    </div>
    <div className="u-text-right">
      <button
        display-if={showGoToProducts}
        type="button"
        className="c-btn u-mr-"
        onClick={onGoToProducts}
        disabled={submitting}
      >
        {t('appointment:form.charge_buttons.add_products')}
      </button>
      <button
        type="button"
        className="c-btn"
        onClick={onCharge}
        disabled={submitting}
        data-automation-id="button:chargeAppointment"
      >
        {t('appointment:form.charge_buttons.charge_appointment')}
      </button>
    </div>
  </div>
);

GoToRegisterButtons.propTypes = {
  areChangesPending: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  onCharge: PropTypes.func.isRequired,
  onGoToProducts: PropTypes.func.isRequired,
  showGoToProducts: PropTypes.bool,
};

GoToRegisterButtons.defaultProps = {
  areChangesPending: false,
  showGoToProducts: false,
};

export default GoToRegisterButtons;
